"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ListCache = _interopRequireDefault(require("./_ListCache.js"));
var _Map = _interopRequireDefault(require("./_Map.js"));
var _MapCache = _interopRequireDefault(require("./_MapCache.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache.default) {
    var pairs = data.__data__;
    if (!_Map.default || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache.default(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _default = exports.default = stackSet;